import styled from "@emotion/styled"

const HeroCaseItemText = styled.span`
  font-weight: 400;
`

export default HeroCaseItemText
